export type AtsSourceLinkSource = 'ESTAFF' | 'SKILLAZ';

export type AtsSourceLinkOption = {
  value: AtsSourceLinkSource;
  label: string;
  searchSource: Lowercase<AtsSourceLinkSource>;
};

export const ATS_SOURCE_LINK_OPTIONS: AtsSourceLinkOption[] = [
  { value: 'ESTAFF', label: 'E-Staff', searchSource: 'estaff' },
  { value: 'SKILLAZ', label: 'Skillaz', searchSource: 'skillaz' },
];

export function buildAvailableAtsSourceLinkOptions(response: unknown): AtsSourceLinkOption[] {
  const sources = Array.isArray((response as { sources?: unknown[] } | null)?.sources)
    ? (response as { sources: Array<{ id?: unknown; available?: unknown }> }).sources
    : [];

  const availableSourceIds = new Set(
    sources
      .filter((source) => source?.available === true)
      .map((source) => String(source?.id || '').trim().toLowerCase())
      .filter(Boolean)
  );

  return ATS_SOURCE_LINK_OPTIONS.filter((option) => availableSourceIds.has(option.searchSource));
}

export function getValidAtsSourceLinkSource(
  currentSource: string,
  options: AtsSourceLinkOption[]
): AtsSourceLinkSource | '' {
  const normalizedCurrent = String(currentSource || '').trim().toUpperCase();
  const currentOption = options.find((option) => option.value === normalizedCurrent);

  return currentOption?.value ?? options[0]?.value ?? '';
}
